export default [{
  name: 'apply/info',
  path: '/apply/info',
  meta: {
    needLogin: true
  },
  component: () => import('../view/apply/info.vue')
}, {
  name: 'apply/profile',
  path: '/apply/profile',
  meta: {
    needLogin: true
  },
  component: () => import('../view/apply/profile.vue')
}, {
  name: 'apply/proving',
  path: '/apply/proving',
  meta: {
    needLogin: true
  },
  component: () => import('../view/apply/proving.vue')
}, {
  name: 'apply/bank',
  path: '/apply/bank',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/apply/bank.vue')
}, {
  name: 'apply/result',
  path: '/apply/result',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/apply/result.vue')
}, {
  name: 'apply/prepass',
  path: '/apply/prepass',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/apply/result-no.vue')
}, {
  name: 'apply/history',
  path: '/apply/history',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/apply/history.vue')
}, {
  name: 'apply/detail',
  path: '/apply/detail/:type/:applyId',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/apply/detail.vue')
}, {
  name: 'apply/schedule',
  path: '/apply/schedule',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/apply/schedule.vue')
}]